import './index.web.css';

const runWebEntry = async () => {
  if (window.location.pathname === '/dashboardPreview') {
    // eslint-disable-next-line no-restricted-syntax -- Keep the isolated preview free of normal App startup.
    const { runDashboardPreviewWebEntry } = await import('./webEntry/DashboardPreviewWebEntry');

    runDashboardPreviewWebEntry();
    return;
  }

  // eslint-disable-next-line no-restricted-syntax -- Load the normal App only after excluding the isolated preview route.
  const { runNormalWebEntry } = await import('./webEntry/NormalWebEntry');

  runNormalWebEntry();
};

runWebEntry();
